import { render, staticRenderFns } from "./TrophySvg.vue?vue&type=template&id=76e29159&"
import script from "./TrophySvg.vue?vue&type=script&lang=ts&"
export * from "./TrophySvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports